import React, { Component, Fragment } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
//import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import {
  clearCurrentProfile,
  logoutUser,
  currentUser
} from "./actions/authActions";

import { Provider } from "react-redux";
import store from "./store";

import PrivateRoute from "./components/common/PrivateRoute";

// import Navbar from "./components/layout/Navbar";
//import Footer from "./components/layout/Footer";

import Login from "./components/auth/Login";
import Dashboard from "./components/dashboard";
import User from "./components/User";
import Admin from "./components/Admin";
import Property from "./components/Property";
import ViewProperty from "./components/Property/ViewProperty";

import NotFound from "./components/not-found/NotFound";
import "react-table/react-table.css";
import "./assets/dist/css/AdminLTE.min.css";
import "./assets/dist/css/skins/_all-skins.min.css";
import "./assets/plugins/iCheck/flat/blue.css";
//import "./assets/bootstrap/css/bootstrap.min.css";

// Check for token
if (localStorage.jwtToken) {
  // Set auth token header auth
  setAuthToken(localStorage.jwtToken);
  store.dispatch(currentUser());
  /*  // Decode token and get user info and exp
  const decoded = jwt_decode(localStorage.jwtToken);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));
  
 */

  if (!localStorage.jwtToken) {
    // Logout user
    store.dispatch(logoutUser());
    // Clear current Profile
    store.dispatch(clearCurrentProfile());
    // Redirect to login
    window.location.href = `${window.location.origin.toString()}/`;
    // window.location.href = "http://aqar.tecnovaters.com/";
  }
}

class App extends Component {
  componentDidMount() {}
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div>
            <Route exact path="/" component={Login} />
            <Route exact path="/login" component={Login} />

            {/* <Route exact path="/dashboard" component={Dashboard} /> */}
            <Switch>
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
            </Switch>
            <Switch>
              <PrivateRoute exact path="/user" component={User} />
            </Switch>
            <Switch>
              <PrivateRoute exact path="/admin" component={Admin} />
            </Switch>
            <Switch>
              <PrivateRoute exact path="/property" component={Property} />
            </Switch>
            <Switch>
              <PrivateRoute
                exact
                path="/property/:id"
                component={ViewProperty}
              />
            </Switch>

            {/*   <Switch>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
              </Switch> */}
            {/* <PrivateRoute exact path="/user" component={User} /> */}
            {/*             <Switch>
                <PrivateRoute
                  exact
                  path="/create-profile"
                  component={CreateProfile}
                />
              </Switch>
              <Switch>
                <PrivateRoute
                  exact
                  path="/edit-profile"
                  component={EditProfile}
                />
              </Switch>
              <Switch>
                <PrivateRoute
                  exact
                  path="/add-experience"
                  component={AddExperience}
                />
              </Switch>
              <Switch>
                <PrivateRoute
                  exact
                  path="/add-education"
                  component={AddEducation}
                />
              </Switch>
              <Switch>
                <PrivateRoute exact path="/feed" component={Posts} />
              </Switch>
              <Switch>
                <PrivateRoute exact path="/post/:id" component={Post} />
              </Switch> */}
            <Route exact path="/not-found" component={NotFound} />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js